/** @format */

import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {AppHeader, Stack} from 'ui';

import {ROUTES} from 'constants/ROUTES';

import {Content, Page, PageLead, PageTitle} from '../../../styles';
import {BackLink} from './styles';

export interface ReportUnavailableProps {
  title: string;
  /** Подпись под заголовком: чем именно кончилось дело. */
  detail?: string | null;
  /**
   * Выходы со страницы: ссылка в архив и переход по логотипу.
   *
   * Гостю их не дают. Оба адреса ведут в кабинет, куда ему нельзя, и
   * посторонний человек упёршийся бы в форму входа без объяснения, зачем
   * она ему показана.
   */
  exits?: boolean;
}

/**
 * Экран вместо документа.
 *
 * Ссылка в архив обязательна для владельца: на эту страницу приходят по
 * ссылке из письма, и человек, упёршийся в «отчёт ещё собирается», не
 * должен оказаться в тупике без единого выхода. У гостя выхода нет и быть
 * не может — см. `exits`.
 */
export function ReportUnavailable({title, detail, exits = true}: ReportUnavailableProps) {
  const navigate = useNavigate();

  return (
    <Page>
      <AppHeader onLogoClick={exits ? () => navigate(ROUTES.INDEX) : undefined} />
      <Content>
        <Stack gap='l' alignX='start'>
          <PageTitle as='h1'>{title}</PageTitle>
          {detail && <PageLead>{detail}</PageLead>}
          {exits && (
            <BackLink to={`/${ROUTES.REPORTS}`}>
              <Trans>Все отчёты</Trans>
            </BackLink>
          )}
        </Stack>
      </Content>
    </Page>
  );
}
